import { Dispatch, FC, SetStateAction } from "react";
import { TTrackingErrors, TTrackingState } from "../../../hooks/useOrder";
import { icons } from "../../../icons/IconSet";
import Modal from "../../common/Modal";
import Button from "../../form/Button";
import TrackingForm from "./TrackingForm";

/** The button and its modal. What the save does is the caller's business. */
const TrackingWidget: FC<{
  state?: TTrackingState,
  errors?: TTrackingErrors,
  loading?: boolean,
  title?: string,
  buttonTitle: string,
  buttonActionTitle?: string,
  onClick: (state: TTrackingState) => Promise<void>,
  isShown: boolean,
  setIsShown: Dispatch<SetStateAction<boolean>>,
}> = ({
  state,
  title,
  errors,
  loading,
  buttonTitle,
  buttonActionTitle,
  onClick,
  isShown,
  setIsShown,
}) => (
  <div>
    <Button
      className="flex items-center gap-2 whitespace-nowrap"
      isNotFullWidth
      size="small"
      variant="outline"
      onClick={() => setIsShown(() => true)}
    >
      {icons('truck', { width: '1.3em' })} {buttonTitle}
    </Button>

    {/* Mounted only while open: the form seeds its fields from `state` on
        mount, so a closed-but-mounted copy would hold a stale draft. */}
    {isShown && (
      <Modal
        isShown
        title={title}
        style={{ maxWidth: '550px', overflowY: 'visible' }}
        onClose={() => setIsShown(() => false)}
      >
        <TrackingForm
          state={state}
          errors={errors}
          loading={loading}
          buttonTitle={buttonActionTitle || buttonTitle}
          onClick={onClick}
        />
      </Modal>
    )}
  </div>
);

export default TrackingWidget;
